module.exports = __webpack_public_path__ + "img/icon_tb.01793583.png";